module.exports = __webpack_public_path__ + "img/bike.9958d2a7.svg";